import AuthEn from './en/Auth';
import FiltersEn from './en/Filters';
import MainEn from './en/Main';
import UserEn from './en/User';
import EnumsEn from './en/Enums';
import ErrorsEn from './en/Errors';
import ExportEn from './en/Export';
import TransactionsEn from './en/Transactions';
import Deals from './en/Deals';
import TransactionCurrencyEn from './en/TransactionCurrency';
import AccountsEn from './en/Accounts';
import ClientsEn from './en/Clients';
import ClientEn from './en/Client';

export default {
	'en': {
		...AuthEn,
		...FiltersEn,
		...MainEn,
		...UserEn,
		...EnumsEn,
		...ErrorsEn,
		...ExportEn,
		...TransactionsEn,
		...Deals,
		...TransactionCurrencyEn,
		...AccountsEn,
		...ClientsEn,
		...ClientEn,
	}
}